import { ChangeEvent, ComponentPropsWithRef, FocusEvent } from 'react';
import { Controller } from 'react-hook-form';

import { InputSelectTemplateField } from '../input/input-select-template-field';

type InputSelectTemplateFieldControllerProps = Omit<
  ComponentPropsWithRef<typeof InputSelectTemplateField>,
  'name' | 'defaultValue' | 'onChange' | 'onBlur'
> & {
  name: string;
  defaultValue?: string;
  onChange?: (value: string, e: ChangeEvent<HTMLElement>) => void;
  onBlur?: (value: string, e: FocusEvent<HTMLElement>) => void;
};

export function InputSelectTemplateFieldController({
  defaultValue,
  onChange,
  onBlur,
  ...defaultProps
}: InputSelectTemplateFieldControllerProps) {
  return (
    <Controller
      render={({
        field: {
          onChange: onControllerChange,
          onBlur: onControllerBlur,
          value,
        },
        fieldState: { error },
      }) => (
        <InputSelectTemplateField
          {...defaultProps}
          onChange={(val, e) => {
            onControllerChange(val);
            onChange?.(val, e);
          }}
          onBlur={(val, e) => {
            onControllerChange(val);
            onControllerBlur();
            onBlur?.(val, e);
          }}
          value={value ?? ''}
          error={error?.message}
        />
      )}
      name={defaultProps.name}
      defaultValue={defaultValue}
    />
  );
}
